export const openLinkByTag = ({
  link,
  rel = 'noopener noreferrer',
  target = '_blank',
}: {
  link: string;
  target?: string;
  rel?: string;
}) => {
  const linkEl = document.createElement('a');
  linkEl.target = target;
  linkEl.rel = rel;
  linkEl.className = 'hidden';

  linkEl.href = link;

  document.body.appendChild(linkEl);

  linkEl.click();

  document.body.removeChild(linkEl);
};
